import { useCallback } from 'react';
import type { IRecord, IRecordTypeDefinition } from '@platform/core/types';
import { autosaveActionOf } from './autosaveActionOf';
import type { IRecordEditor } from './IRecordEditor';
import { useReassigner } from './useReassigner';

/**
 * Негайне збереження для міні-форми (UIUX forms/form-variants: «зміни зберігаються одразу й пишуться в історію»): вибір (статус,
 * пріоритет, людина, дата, напрям…) зберігається відразу, текст — у чернетку й зберігається `commit` після виходу з поля; значення, що
 * дорівнює збереженому, не зберігається, крім повторного вибору чинного виконавця Owner/Admin простору (autosaveActionOf, рішення 1
 * етапу 11). Повертає редактор із такою зміною полів (для полів міні-форми).
 */
export function useAutosave(editor: IRecordEditor, rt: IRecordTypeDefinition, ws: string, record: IRecord): { editor: IRecordEditor; commit: () => void } {
  const reassigner = useReassigner(ws);
  const { setField, patchNow, save, dirty } = editor;
  const change = useCallback((key: string, value: unknown) => {
    const action = autosaveActionOf(rt, record, key, value, reassigner);
    if (action === 'draft') setField(key, value);
    else if (action === 'patch') void patchNow({ [key]: value });
  }, [rt, record, reassigner, setField, patchNow]);
  const commit = useCallback(() => { if (dirty) void save(); }, [dirty, save]);
  return { editor: { ...editor, setField: change }, commit };
}
